// Optional colour theme for the radio circles. DANGER mirrors the checkbox's CHECKBOX_TYPE.DANGER so a required
// single-select in an error state can turn its circles the danger colour.
export enum RadioButtonTheme {
  DEFAULT = 'DEFAULT',
  DANGER = 'DANGER',
}
